import React from 'react';

const Faq = () => {
  return (
    <section className="bg-bg py-20 sm:py-24">
      <div className="mx-auto max-w-6xl px-6">
        <div className="mx-auto max-w-2xl text-center">
          <p className="text-eyebrow uppercase text-ink-3">
            FAQ
          </p>
          <h2 className="mt-4 text-3xl font-semibold tracking-tight text-ink sm:text-4xl">
            Frequently asked questions
          </h2>
        </div>

        <div className="mx-auto mt-10 grid max-w-4xl gap-4 md:grid-cols-2">
          <details className="rounded-2xl border border-border bg-surface p-5">
            <summary className="cursor-pointer text-sm font-semibold text-ink">
              How many workers can I have?
            </summary>
            <p className="mt-3 text-sm leading-6 text-ink-3">
              Unlimited.
            </p>
          </details>

          <details className="rounded-2xl border border-border bg-surface p-5">
            <summary className="cursor-pointer text-sm font-semibold text-ink">
              What if I finished a job?
            </summary>
            <p className="mt-3 text-sm leading-6 text-ink-3">
              Delete the jobsite. Records stay saved and billing stops for that site.
            </p>
          </details>

          <details className="rounded-2xl border border-border bg-surface p-5">
            <summary className="cursor-pointer text-sm font-semibold text-ink">
              Does it work indoors?
            </summary>
            <p className="mt-3 text-sm leading-6 text-ink-3">
              Yes, with a stable internet connection. If GPS is weak indoors, workers
              should clock in near a window or outside.
            </p>
          </details>

          <details className="rounded-2xl border border-border bg-surface p-5">
            <summary className="cursor-pointer text-sm font-semibold text-ink">
              Some workers are encountering issues. What can I do?
            </summary>
            <p className="mt-3 text-sm leading-6 text-ink-3">
              Devices and carriers vary by worker. Use kiosk mode so designated
              foremen can clock workers in and out when needed.
            </p>
          </details>
        </div>
      </div>
    </section>
  );
};

export default Faq;
